import { render, staticRenderFns } from "./FiltrosEnviarMensagem.vue?vue&type=template&id=8420c02c&"
import script from "./FiltrosEnviarMensagem.vue?vue&type=script&lang=js&"
export * from "./FiltrosEnviarMensagem.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosEnviarMensagem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FiltrosEnviarMensagem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports